import axios from 'axios';

const PARCERIAS_API = 'http://localhost:3000/parcerias';

export const aceitarParceria = async (id) => {
  try {
    await axios.post(`${PARCERIAS_API}/aceitar`, { id });
  } catch (error) {
    console.error('Erro ao aceitar parceria:', error);
  }
};

export const rejeitarParceria = async (id) => {
  try {
    await axios.post(`${PARCERIAS_API}/rejeitar`, { id });
  } catch (error) {
    console.error('Erro ao rejeitar parceria:', error);
  }
};
